import React from "react";

import './About.scss'

const About = ({ isClosed, data, ...rest }) => {

    return (
        <section className={ [`about`, `about--${ isClosed ? `is-closed` : `not-closed` }`].join( ` ` ) }>
            <div className={ `about-wrapper` }>
        {/* {
            console.log(data.pages.about.descriptions)
        } */}

                <article className={ `about-wrapper-main` } >
                    <p className={ `_variable` }> {data.pages.about.descriptions[0].main_text[0]} </p>
                    <p className={ `_variable` }> {data.pages.about.descriptions[0].main_text[1]} </p>
                    <p className={ `_variable` }> {data.pages.about.descriptions[0].main_text[2]} </p>
                    <p className={ `_variable` }> {data.pages.about.descriptions[0].main_text[3]} </p>
                </article>

                <article className={ `about-wrapper-side` }>
                    <div className={ `about-wrapper-side-list _text` }>
                        <ul>
                            <li className={ `strong _text` }>Unfolding Pavilion</li>
                            <li className={ `strong _text` }>Rituals of Solitude</li>
                            <li className={ ` _text` }><a target='_blank' rel="noreferrer" href={`http://ritualsofsolitude.com/`}>ritualsofsolitude.com</a></li>
                        </ul>
                        
                        <ul>
                            <li className={ `strong _text ` }>Curators</li>
                            <li className={ ` _text` }> Daniel Tudor Munteanu, Davide Tommaso Ferrando </li>
                        </ul>
                        
                        <ul>
                            <li className={ `strong _text` }>Illustrator</li>
                            <li className={ ` _text` }><a target='_blank' rel="noreferrer" href={`https://www.mutomuto.com/`}>Giovanni Benedetti</a></li>
                        </ul>
                        <ul>
                            <li className={ `strong _text` }>Web Design and Development,</li>
                            <li className={ `strong _text` }>Sound Design</li>
                            <li className={ ` _text` }><a target='_blank' rel="noreferrer" href={`https://hund.studio/`}>hund</a></li>
                        </ul>
                    </div>

                    <div className={`about-wrapper-side-list _text`}>
                        <ul>
                            <li className={ `strong _text ` }>Sponsors</li>
                            <li className={ ` _text` }>Italien Zentrum / Innsbruck University</li>
                            <li className={ ` _text` }>Department of Architectural Theory / Innsbruck University</li>
                            <li className={ ` _text` }>Dean’s Office / Innsbruck University </li>
                            <li className={ ` _text` }>Office of the Vice Rector for Research / Innsbruck University</li>
                            <li className={ ` _text` }>Faculty of Design and Art / Free University of Bozen-Bolzano</li>
                        </ul>

                        <ul>
                            <li className={ `strong _text `}>Media Partner</li>
                            <li className={ ` _text` }>Domus</li>
                        </ul>
                    </div>

                    <div className={`about-wrapper-side-list _text`}>
                        <ul>
                            <li className={ `strong _text` }>Info</li>
                            <li className={ ` _text` }><a target='_blank' rel="noreferrer" href={`https://unfoldingpavilion.com/`}>unfoldingpavilion.com</a></li>
                        </ul>
                    </div>

                </article>

            </div>
        </section>
    )
}

export default About